export default __webpack_public_path__ + "static/media/battery.565f437c.png";